/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
  DailyReward,
  DailyRewardFromJSON,
  DailyRewardToJSON,
  TotalReward,
  TotalRewardFromJSON,
  TotalRewardToJSON,
} from '../models'

/**
 *
 */
export class RewardsApi extends runtime.BaseAPI {
  /**
   */
  async getDailyRewardsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<DailyReward>>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/rewards/daily`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DailyRewardFromJSON))
  }

  /**
   */
  async getDailyRewards(initOverrides?: RequestInit): Promise<Array<DailyReward>> {
    const response = await this.getDailyRewardsRaw(initOverrides)
    return await response.value()
  }

  /**
   */
  async getTotalEarnedRewardsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<TotalReward>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/private/rewards/total-earned`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) => TotalRewardFromJSON(jsonValue))
  }

  /**
   */
  async getTotalEarnedRewards(initOverrides?: RequestInit): Promise<TotalReward> {
    const response = await this.getTotalEarnedRewardsRaw(initOverrides)
    return await response.value()
  }
}
